<template>
    <div v-auto-animate>
        <input
            :type="inputType"
            :name="inputName"
            :placeholder="inputPlaceholder"
            :maxlength="inputMaxLength"
            :value="inputValue"
            :class="[
                showErrorMessage ? 'border-red text-red-error focus:ring-red focus:border-red' : 'border-gray-light focus:ring-black focus:border-black',
                'rounded-sm border w-full h-12 px-2 bg-white focus:outline-none focus:ring-1 font-oceanside placeholder:text-gray-dark placeholder:text-[14px]'
            ]"
        >

        <div
            v-if="showCharacterCount"
            :class="[
                'text-[14px] mt-1 text-right absolute right-4 top-[8px]',
                showErrorMessage ? 'text-red-error' : characterCount >= 1 ? 'text-black' : 'text-gray-dark',
            ]"
        >
            [{{ characterCount }}/{{ inputMaxLength }}]
        </div>

        <p
            v-if="inputMessage"
            class="mt-2 text-xs"
        >
            {{ inputMessage }}
        </p>

        <base-error-message v-if="showErrorMessage">
            {{ errorMessage }}
        </base-error-message>
    </div>
</template>

<script>
    import BaseErrorMessage from './BaseErrorMessage.vue';

    export default {
        components: {
            BaseErrorMessage,
        },

        props: {
            inputType: {
                type: String,
                default: 'text',
            },
            inputName: {
                type: String,
                required: true,
            },
            inputPlaceholder: {
                type: String,
                default: '',
            },
            inputValue: {
                type: String,
                default: '',
            },
            inputMessage: {
                type: String,
                default: '',
            },
            inputMaxLength: {
                type: Number,
                default: null,
            },
            errorMessage: {
                type: String,
                default: '',
            },
            showErrorMessage: {
                type: Boolean,
                default: false,
            },
            showCharacterCount: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            characterCount() {
                return this.inputValue.length;
            },
        },
    };
</script>
